import { createFileRoute, useRouterState } from '@tanstack/react-router';
import { PlannerPage } from '@/features/missions/PlannerPage';

export const Route = createFileRoute('/_staff/staff/missions/new')({ component: NewMissionPage });

/** Opens empty, or prefilled from a draft passed in history state (a duplicate); a reload keeps it. */
function NewMissionPage() {
  const draft = useRouterState({ select: (s) => s.location.state.missionDraft });
  return <PlannerPage mission={draft} />;
}
